var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sidebar-menu-container" }, [
    _c("div", { staticClass: "sidebar-main-label" }, [_vm._v("Наличники")]),
    _vm._v(" "),
    _c("div", { staticClass: "sidebar-text-area" }, [
      _vm._v("\n            Выберите режим редактированя:\n        ")
    ]),
    _vm._v(" "),
    _c(
      "select",
      {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.activePlatbandToolMode,
            expression: "activePlatbandToolMode"
          }
        ],
        staticClass: "cd-modal-text-input",
        on: {
          change: [
            function($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function(o) {
                  return o.selected
                })
                .map(function(o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.activePlatbandToolMode = $event.target.multiple
                ? $$selectedVal
                : $$selectedVal[0]
            },
            function($event) {
              return _vm.changePlatbnandMode()
            }
          ]
        }
      },
      [
        _c("option", { attrs: { value: "scaling" } }, [
          _vm._v("Масштабирование")
        ]),
        _vm._v(" "),
        _c("option", { attrs: { value: "moving" } }, [
          _vm._v("Изменение геометрии")
        ]),
        _vm._v(" "),
        _c("option", { attrs: { value: "centering" } }, [_vm._v("Перемещение")])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activePlatbandToolMode === "scaling",
            expression: "activePlatbandToolMode === 'scaling'"
          }
        ]
      },
      [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "sidebar-step-two-img-container" }, [
          _c("img", {
            staticClass: "sidebar-step-two-img",
            attrs: { src: _vm.urlForStatic("/img/platband_tip.png") }
          })
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activePlatbandToolMode === "moving",
            expression: "activePlatbandToolMode === 'moving'"
          }
        ]
      },
      [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "sidebar-step-two-img-container" }, [
          _c("img", {
            staticClass: "sidebar-step-two-img",
            attrs: { src: _vm.urlForStatic("/img/platband_tip_2.png") }
          })
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activePlatbandToolMode === "centering",
            expression: "activePlatbandToolMode === 'centering'"
          }
        ]
      },
      [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "sidebar-step-two-img-container" }, [
          _c("img", {
            staticClass: "sidebar-step-two-img",
            attrs: { src: _vm.urlForStatic("/img/platband_tip_3.png") }
          })
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sidebar-text-area" }, [
      _vm._v("В режиме "),
      _c("span", { staticClass: "red-text bold-text" }, [
        _vm._v('"масштабирование"')
      ]),
      _vm._v(
        " можно изменять рамер наличника с сохранением исходных пропорций. Для масштабирования\n                "
      ),
      _c("span", { staticClass: "red-text bold-text" }, [
        _vm._v("переместитие")
      ]),
      _vm._v(" любую "),
      _c("span", { staticClass: "red-text bold-text" }, [_vm._v("точку")]),
      _vm._v(" плоскости, как показано на рисунке.\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sidebar-text-area" }, [
      _vm._v("В режиме "),
      _c("span", { staticClass: "red-text bold-text" }, [
        _vm._v('"изменение геометрии"')
      ]),
      _vm._v(
        " можно произвольно перемещать угловые точки наличника, изменяя его форму. Для этого\n                "
      ),
      _c("span", { staticClass: "red-text bold-text" }, [
        _vm._v("переместитие")
      ]),
      _vm._v(" любую "),
      _c("span", { staticClass: "red-text bold-text" }, [_vm._v("точку")]),
      _vm._v(" плоскости, как показано на рисунке.\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sidebar-text-area" }, [
      _vm._v("В режиме "),
      _c("span", { staticClass: "red-text bold-text" }, [
        _vm._v('"перемещение"')
      ]),
      _vm._v(
        " можно равномерно сдвигать плоскость наличника. Для этого\n                "
      ),
      _c("span", { staticClass: "red-text bold-text" }, [
        _vm._v("переместитие")
      ]),
      _vm._v(" любую "),
      _c("span", { staticClass: "red-text bold-text" }, [_vm._v("точку")]),
      _vm._v(" плоскости, как показано на рисунке.\n            ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }